import Vue from 'vue';
import Vuex from 'vuex';
import { CONFIG, LANG, dataService } from "../shared";
import { ADD_EVENT, GET_EVENTS, GET_USEREVENTS, SET_TIMES, LOGIN, CHECK_LOGIN, LOGOUT, DELETE_EVENT } from "./mutation-types";

Vue.use(Vuex);

const state = {
  events: [],
  userevents: [],
  user: {},
  times: {},
  language: LANG[CONFIG.lang.default],
  langcode: CONFIG.lang.default,
};

const storageItem = 'tenniscalendar_' + CONFIG.token;

const mutations = {
  [GET_EVENTS](state, events)
  {
    state.events = events;
  },
  [GET_USEREVENTS](state, events)
  {
    state.userevents = events;
  },
  [LOGIN](state, user)
  {
    // what to storage in localStorage
    const storage = {
      id: user.id,
      token: user.token,
      email: user.email,
      name: user.name,
      lastname: user.lastname,
      admin: user.admin,
    };

    localStorage.setItem(storageItem, JSON.stringify(storage));

    state.user = storage;
  },
  [CHECK_LOGIN](state)
  {
    if (localStorage.getItem(storageItem))
    {
      state.user = JSON.parse(localStorage.getItem(storageItem));
    }
  },
  [LOGOUT](state)
  {
    localStorage.removeItem(storageItem);

    state.user = {};
    state.userevents = [];
  },
  [SET_TIMES](state, data)
  {
    state.times = data;
  }
};

const actions = {
  async [GET_EVENTS]({ commit }, param)
  {
    const events = await dataService.getEvents(getters.userIsAdmin(state), getters.getUserId(state), state.userevents, param.start, param.end);

    commit(GET_EVENTS, events);
  },
  async [GET_USEREVENTS]({ commit })
  {
    const events = await dataService.getUserEvents(state.user.token);

    commit(GET_USEREVENTS, events);
  },
  async [ADD_EVENT]({ dispatch }, event)
  {
    const response = await dataService.addEvent(event);

    await dispatch(GET_USEREVENTS);

    return response;
  },
  async [DELETE_EVENT]({ dispatch }, token)
  {
    const response = await dataService.deleteEvent(token);

    await dispatch(GET_USEREVENTS);

    return response;
  },
  async [LOGIN]({ commit, dispatch }, form)
  {
    const response = await dataService.login(form);

    if (response.status == 200)
    {
      commit(LOGIN, response.data.user);

      await dispatch(GET_USEREVENTS);
    }

    return response;
  },
  [CHECK_LOGIN]({ commit })
  {
    commit(CHECK_LOGIN);
  },
  [LOGOUT]({ commit })
  {
    commit(LOGOUT);
  },
  [SET_TIMES]({ commit }, param)
  {
    commit(SET_TIMES, param);
  }
};

const getters = {
  getUserId: state => state.user.id ? state.user.id : 0,
  getUserToken: state => state.user.token,
  getUserName: state => `${state.user.name} ${state.user.lastname}`,
  getUserFirstName: state => state.user.name,
  userIsAdmin: state => state.user.admin == CONFIG.token ? true : false,
  getCalendarTimes: state => state.times,
  getLanguage: state => state.language,
  getLangCode: state => state.langcode
};

// const plugin = store => {
//   store.subscribe((mutation, state) => {
//     console.log(mutation);
//     console.log(state);
//   })
// };

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  // plugins: [ plugin ],
});

export default store;
